const AUTH_CONFIG =  {
  "domain": "bluehexagon.auth0.com",
  "clientId": "O5mGnzrowgrGvnLddYOSFGU8pT5bKTlM",
  "redirectUri": window.env.CALLBACK_URL + "callback"
}

export default AUTH_CONFIG;
